 import React from 'react';

export default class CustomPrice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            prodotti: props.prodotti,
            prodotto: props.value.prodottoId,
            price: props.value.price,
        };
    }

    componentDidUpdate() {
        if (this.props.value.prodottoId !== this.state.prodotto || this.props.value.price !== this.state.price) {
            this.setState({
                prodotto: this.props.value.prodottoId,
                price: this.props.value.price,
            })
        }
    }

    render() {
        return(
            <div style={mainStyle}>
                <div style={childContainer}>
                    <p style={{ ...child, marginTop: 10 }} >Prodotto:</p>
                    <select style={{ ...child, height: 40 }} value={this.state.prodotto}
                        onChange={(e) => {        
                            if (this.props.onProdottoSelect) {
                                this.props.onProdottoSelect(e.target.value);
                            }
                            var prezzo = e.target.options[e.target.selectedIndex].getAttribute('data-price');
                            this.setState({prodotto: e.target.value});
                            if (this.props.onPriceUpdate) {
                                this.props.onPriceUpdate(prezzo);
                            }
                        }}>
                        <option key={0} id={0} value={undefined} >{undefined}</option>
                        {this.state.prodotti.map((p) => {
                            return(
                                <option key={p.id} id={p.id} value={p.id} data-price={p.prezzo} >{p.nome}</option>
                            );
                        })}
                    </select>
                </div>
                <div style={childContainer}>
                    <p style={{ ...child, marginTop: 10 }} >Prezzo:</p>
                    <input style={{ ...child, ...inputChild }} type='number' value={this.state.price} 
                        onChange={(e) => {
                            if (this.props.onPriceUpdate) {
                                this.props.onPriceUpdate(e.target.value);
                            }
                            this.setState({price: e.target.value});
                        }} 
                    />
                </div>
                <img src={require('../images/close.png')} alt="" title="Rimuvi" style={{ cursor: 'pointer', width: 15, height: 15, marginLeft: 10, marginRight: -5, marginTop: 12 }} onClick={() => this.props.onDelete()} />
            </div>
        );
    }
}

const mainStyle = {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'space-between',
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxWidth: 500,
    maxHeight: 60,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
};

const inputChild = {
    height: 40, 
    width: 80,
}

const child = {
    marginLeft: 5,
    height: 40,
}

const childContainer = {
    height: 40,
    display: 'flex',
    flexDirection: 'row',
}
 